
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/powertrain",
      function () {
        return require("private-next-pages/powertrain.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/powertrain"])
      });
    }
  